
import React, { useState } from "react";

import { BaseFilterPopover } from "./popover";
import { defaultSlots, FilterSlotProps, FilterSlots } from "./slots";

export type BaseFilterProps = {
  label: string;
  open?: boolean;
  slots?: FilterSlots;
  isLoading?: boolean;
  filterable?: boolean;
  hasChanges?: boolean;
  onClose?: () => void;
  onClear?: () => void;
  appliedCount?: number;
  isInitiallyOpen?: boolean;
  onApplyChanges?: () => void;
  slotProps?: FilterSlotProps;
  canRemoveWhenEmpty?: boolean;
};

export const BaseFilter = ({
  slots,
  label,
  onClose,
  onClear,
  slotProps,
  appliedCount,
  onApplyChanges,
  isInitiallyOpen,
  open: controlledOpen,
  canRemoveWhenEmpty,
  ...rest
}: BaseFilterProps) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [uncontrolledOpen, setUncontrolledOpen] = useState(!!isInitiallyOpen);

  const isControlled = controlledOpen !== undefined;

  const handleClose = () => {
    if (!isControlled) {
      setUncontrolledOpen(false);
    }
    if (onClose) {
      onClose();
    }
  };

  const handleApplyChanges = () => {
    if (!isControlled) {
      setUncontrolledOpen(false);
    }
    if (onApplyChanges) {
      onApplyChanges();
    }
  };

  const handleButtonClick = () => {
    if (!isControlled) {
      setUncontrolledOpen(true);
    }
  };

  const mergedSlots = { ...defaultSlots, ...slots };
  const isPopoverOpen = isControlled ? controlledOpen : uncontrolledOpen;

  return (
    <>
      {mergedSlots.button({
        label,
        onClear,
        appliedCount,
        canRemoveWhenEmpty,
        onClick: handleButtonClick,
        ref: (el) => setAnchorEl(el),
        ...slotProps?.button,
      })}
      {anchorEl && (
        <BaseFilterPopover
          slots={slots}
          label={label}
          open={isPopoverOpen}
          slotProps={slotProps}
          onClose={handleClose}
          anchorEl={anchorEl}
          onApplyChanges={handleApplyChanges}
          {...rest}
        />
      )}
    </>
  );
};
